<div class="info-popover flex flex-col items-center justify-center gap-2.5">
  <span class="title">Páginas por cara</span>
  <div class="section flex flex-row gap-2.5">
    <img src="assets/images/tooltip-info-components/pagesPerSheet/1.png" />
    <div class="flex flex-col gap-1.5">
      <span class="section_title">1 página por cara</span>
      <span class="section_info"
        >Se imprime una página de tu documento por cada cara del folio. Es la opción más común.</span
      >
    </div>
  </div>
  <div class="section flex flex-row gap-2.5">
    <img src="assets/images/tooltip-info-components/pagesPerSheet/2.png" />
    <div class="flex flex-col gap-1.5">
      <span class="section_title">2 páginas por cara</span>
      <span class="section_info">Se imprimen dos páginas de tu documento por cada cara del folio.</span>
    </div>
  </div>
  <div class="section flex flex-row gap-2.5">
    <img src="assets/images/tooltip-info-components/pagesPerSheet/4.png" />
    <div class="flex flex-col gap-1.5">
      <span class="section_title">4 páginas por cara</span>
      <span class="section_info">Se imprimen cuatro páginas de tu documento por cada cara del folio.</span>
    </div>
  </div>
</div>
